<div class="card-inline">
    <h3>Medico derivante</h3>
</div>
<!-- <div class="card-inline">
    <button (click)="edit()" mat-mini-fab>
<mat-icon>edit</mat-icon>
</button>
</div> -->
<mat-divider></mat-divider>
<div class="margin-top-medium">
    <form [formGroup]="form">
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Apellido" formControlName="LastName">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Nombre" formControlName="FirstName">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Sexo" formControlName="Sex">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Matrícula nacional" formControlName="NationalRegistration">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Matrícula provincial" formControlName="ProvincialRegistration">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Matrícula especialidad" formControlName="SpecialityRegistration">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Relevancia" formControlName="Relevance">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="País" formControlName="Country">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Provincia" formControlName="Province">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Localidad" formControlName="Locality">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Calle" formControlName="AddressStreet">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Nro" formControlName="AddressNumber">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Piso" formControlName="Floor">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Depto." formControlName="AddressDpto">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Teléfono particular" formControlName="PersonalPhone">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Teléfono laboral" formControlName="LaborPhone">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Celular" formControlName="CellPhone">
        </mat-form-field>
        <mat-form-field class="margin-right-xs">
            <input matInput placeholder="Email" formControlName="Email">
        </mat-form-field>
    </form>
</div>